<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <h3>{{ $t('Conversaciones') }}</h3>
      </v-card-title>

      <v-toolbar extension-height="130px" color="white" class="pb-0 mb-0">
        <v-dialog v-model="threadForm" persistent max-width="964px">
          <v-btn slot="activator" color="primary">
            {{ $t('Nueva Conversación') }}
          </v-btn>
          <admin-thread-form
            :customers="customers ? customers : []"
            @created="addThread"
            @closeForm="threadForm = false"
          ></admin-thread-form>
        </v-dialog>
        <v-btn @click="restoreFilters()" color="secondary">
          {{ $t('Restaurar filtros') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          solo
          color="primary"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          @click:append="searchThread"
          single-line
          hide-details
        ></v-text-field>

        <v-layout
          align-center
          justify-end
          row
          fill-height
          wrap
          slot="extension"
          class="white--text"
        >
          <v-flex xs6>
            <og-user-select multiple v-model="customers"></og-user-select>
          </v-flex>
          <v-flex xs3>
            <v-select
              solo
              class="ml-3"
              color="primary"
              v-model="myCustomers"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'No filtrar', value: false },
                { text: 'Sólo mis clientes', value: true },
              ]"
              row
            ></v-select>
          </v-flex>

          <v-flex xs3>
            <clavedat-selector
              v-model="clavedat"
              multiple
              label="Empresas"
              class="ml-3"
              solo
            ></clavedat-selector>
          </v-flex>

          <v-flex xs3 class="og-select-category">
            <category-select
              solo
              class="mr-3"
              color="primary"
              v-model="categories"
            ></category-select>
          </v-flex>
          <v-flex xs2>
            <v-select
              solo
              color="primary"
              v-model="status"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'Todas (Activas + Cerradas)', value: null },
                { text: 'Activas', value: 'active' },
                { text: 'Cerradas', value: 'closed' },
              ]"
              row
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-select
              solo
              class="ml-3"
              color="primary"
              v-model="read"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'Todas (Leídas + No leídas)', value: null },
                { text: 'Leídas', value: 'true' },
                { text: 'No leídas', value: 'false' },
              ]"
              row
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-switch class="ml-3" v-model="unreadMessages" :label="'Mensajes sin leer'"></v-switch>
          </v-flex>
          <v-flex xs3>
            <v-switch class="ml-3" v-model="premiumUsers" :label="'Clientes premium'"></v-switch>
          </v-flex>

          <!-- <div class="mx-3">
                        <v-checkbox  color="primary" :label="$t('Activas')" v-model="active"></v-checkbox>
                    </div>
                    <div class="mx-3">
                        <v-checkbox  color="primary" :label="$t('Cerradas')" v-model="closed"></v-checkbox>
          </div>-->
        </v-layout>
      </v-toolbar>
      <v-progress-linear
        v-if="loading"
        class="py-0 my-0"
        height="3"
        :indeterminate="loading"
      ></v-progress-linear>

      <v-list three-line class="og-thread-list">
        <template v-for="thread in threads">
          <v-list-tile
            :key="thread.id"
            avatar
            @click="threadDetail(thread.id)"
            v-bind:class="{ 'unread-thread': !thread.read }"
          >
            <v-list-tile-action mr-2>
              <v-badge
                v-if="thread.unreaded_messages"
                size="24"
                color="secondary"
                class="admin-thread-notification-badge"
                overlap
              >
                <span slot="badge">{{ thread.unreaded_messages }}</span>
                <user-avatar :size="40" no-name :user="thread.user"></user-avatar>
              </v-badge>
              <user-avatar v-else :size="40" no-name :user="thread.user"></user-avatar>

              <!-- <user-avatar :size="40" no-name :user="thread.user"></user-avatar> -->
              <!-- <category-icon x-large :category="thread.category"></category-icon> -->
            </v-list-tile-action>
            <v-list-tile-content>
              <div class="og-thread-content">
                <div>
                  <b v-if="!!thread && !!thread.user && !!thread.user.name">
                    {{ thread.user.name }}
                    <template
                      v-if="
                        !!thread.user.customer_profile && !!thread.user.customer_profile.fiscal_data
                      "
                    >
                      <span class="ml-2">
                        [
                        <template v-for="(data, i) in thread.user.customer_profile.fiscal_data">
                          <span :key="`cli-more-${i}`" v-if="i > 0" class="ml-1 mr-1">-</span>
                          <span :key="`cli-${i}`">{{ data.CLAVEDAT }}</span>
                        </template>
                        ]
                      </span>
                    </template>
                    <v-icon
                      v-if="!!thread && !!thread.user && !!thread.user.premium"
                      class="ml-2"
                      color="secondary"
                    >
                      mdi-star-circle
                    </v-icon>
                    <v-icon
                      v-if="!!thread && !!thread.user && !!thread.user.non_payment"
                      class="ml-2"
                      color="error"
                    >
                      <!-- mdi-alarm-light -->
                      mdi-skull-crossbones
                    </v-icon>
                  </b>
                  <b v-else>{{ $t('Usuario desconocido') }}</b>

                  <v-list-tile-title>{{ thread.title }}</v-list-tile-title>

                  <v-list-tile-sub-title>
                    <message-excerpt :message="lastComment(thread)"></message-excerpt>
                  </v-list-tile-sub-title>
                </div>
                <div>
                  <v-chip v-if="!!thread && !!thread.company_name">
                    {{ thread.company_name }}
                  </v-chip>
                </div>
              </div>
            </v-list-tile-content>
            <v-list-tile-action class="mr-3">
              <v-badge color="primary" overlap>
                <span slot="badge">{{ thread.messages_count }}</span>
                <v-icon color="grey">mdi-message-text</v-icon>
              </v-badge>
            </v-list-tile-action>
            <v-list-tile-action>
              <status-widget :status="thread.status"></status-widget>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-btn icon flat>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="'divider-' + thread.id"></v-divider>
        </template>
      </v-list>
      <div class="text-xs-center">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </v-card>
    <v-snackbar
      v-model="notification.snackbar"
      :bottom="notification.y === 'bottom'"
      :color="notification.color"
      :left="notification.x === 'left'"
      :multi-line="notification.mode === 'multi-line'"
      :right="notification.x === 'right'"
      :timeout="notification.timeout"
      :top="notification.y === 'top'"
      :vertical="notification.mode === 'vertical'"
    >
      {{ notification.text }}

      <v-btn dark text @click="notification.snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
import StatusWidget from '@/components/commons/StatusWidget.vue';
import ThreadAPI from '@/modules/myconsultant/services/thread.js';
import MessageExcerpt from '@/components/commons/MessageExcerpt.vue';
import CategorySelect from '@/components/commons/CategorySelect.vue';
import OgUserSelect from '@/components/commons/form/inputs/OgUserSelect.vue';
import UserAvatar from '@/components/commons/UserAvatar.vue';
import AdminThreadForm from './AdminThreadForm.vue';
import ClavedatSelector from '@/components/commons/form/inputs/ClavedatSelector.vue';

export default {
  components: {
    StatusWidget,
    MessageExcerpt,
    CategorySelect,
    OgUserSelect,
    UserAvatar,
    AdminThreadForm,
    ClavedatSelector,
  },
  data() {
    return {
      threadForm: false,
      // customers: [],
      // page: 1,
      // search: "",
      // status: "active",
      // categories: [],
      threads: [],
      loading: true,
      // myCustomers: true,
      // params: {
      //   search: {
      //     search: ""
      //   },
      //   myCustomers: true,
      //   status: "active",
      //   users: [],
      //   categories: null,
      //   page: 1,
      //   where: {}
      // },
      pagination: {
        current_page: 1,
        from: 1,
        last_page: null,
        per_page: 15,
        to: null,
        total: null,
      },
      notification: {
        color: '',
        mode: 'multi-line',
        snackbar: false,
        text: '',
        timeout: 6000,
        x: '',
        y: 'top',
      },
    };
  },
  computed: {
    customers: {
      get() {
        return this.$store.getters['adminConv/customers'];
      },
      set(value) {
        this.$store.commit('adminConv/customers', value);
      },
    },
    page: {
      get() {
        return this.$store.getters['adminConv/page'];
      },
      set(value) {
        this.$store.commit('adminConv/page', value);
      },
    },
    search: {
      get() {
        return this.$store.getters['adminConv/search'];
      },
      set(value) {
        this.$store.commit('adminConv/search', value);
      },
    },
    status: {
      get() {
        return this.$store.getters['adminConv/status'];
      },
      set(value) {
        this.$store.commit('adminConv/status', value);
      },
    },
    categories: {
      get() {
        return this.$store.getters['adminConv/categories'];
      },
      set(value) {
        this.$store.commit('adminConv/categories', value);
      },
    },
    myCustomers: {
      get() {
        return this.$store.getters['adminConv/myCustomers'];
      },
      set(value) {
        this.$store.commit('adminConv/myCustomers', value);
      },
    },
    params: {
      get() {
        return this.$store.getters['adminConv/params'];
      },
      set(value) {
        this.$store.commit('adminConv/params', value);
      },
    },
    read: {
      get() {
        return this.$store.getters['adminConv/read'];
      },
      set(value) {
        this.$store.commit('adminConv/read', value);
      },
    },
    unreadMessages: {
      get() {
        return this.$store.getters['adminConv/unreadMessages'];
      },
      set(value) {
        this.$store.commit('adminConv/unreadMessages', value);
      },
    },
    premiumUsers: {
      get() {
        return this.$store.getters['adminConv/premiumUsers'];
      },
      set(value) {
        this.$store.commit('adminConv/premiumUsers', value);
      },
    },
    clavedat: {
      get() {
        return this.$store.getters['adminConv/clavedat'];
      },
      set(value) {
        this.$store.commit('adminConv/clavedat', value);
      },
    },
  },
  async mounted() {
    // if (
    //   this.$store.state.hasOwnProperty("user") &&
    //   this.$store.state.user &&
    //   this.$store.state.user.hasOwnProperty("consultant_profile") &&
    //   this.$store.state.user.consultant_profile &&
    //   this.$store.state.user.consultant_profile.hasOwnProperty("categories") &&
    //   this.$store.state.user.consultant_profile.categories
    // ) {
    //   const categories = [];
    //   this.$store.state.user.consultant_profile.categories.forEach(element => {
    //     categories.push(element.name);
    //   });
    //   this.$store.commit('adminConv/categories', categories);
    //   console.log({ CATEGORIES: this.categories });
    //   // this.params.categories = this.categories;
    // }
    this.searchThread();
  },
  methods: {
    searchThread: function() {
      console.log('PARAMS', this.params);
      this.loading = true;
      ThreadAPI.getThreadSearchPaginate(this.params).then(response => {
        this.threads = response.data.data;
        this.pagination = response.data.meta;
        this.loading = false;
      });
    },

    threadDetail: function(thread) {
      this.$router.push({
        name: 'threadAdminDetail',
        params: { thread: thread },
      });
      // console.log('clicked');
    },
    lastComment: function(thread) {
      return thread.messages.slice(-1)[0];
    },
    searchIfStop: function(val) {
      if (val === this.search) {
        this.page = 1;
        this.searchThread();
      }
    },
    addThread: function(data) {
      console.log('CREATED', data);
      if (data !== 'multiple' && data.data !== 'multiple') {
        this.$router.push('/admin/conversations/thread/' + data.data.id);
      } else {
        this.threadForm = false;
        this.notification.color = 'success';
        this.notification.text = 'Mensajes enviados con éxito';
        this.notification.snackbar = true;
        this.searchThread();
      }
    },
    restoreFilters() {
      this.$store.dispatch('adminConv/resetParams');
    },
  },
  watch: {
    clavedat: function(val, oldVal) {
      this.searchThread();
    },
    myCustomers: function(val, oldVal) {
      console.log({ MYCUSTOMERS: val });
      // this.params.myCustomers = val;
      // this.page = 1;
      this.searchThread();
    },
    customers: {
      handler: function(val, oldVal) {
        console.log(val);
        // this.params.users = val;
        // this.page = 1;
        this.searchThread();
      },
      deep: true,
    },
    categories: {
      handler: function(val, oldVal) {
        console.log(val);
        // console.log(val);
        // this.params.categories = val;
        // this.page = 1;
        this.searchThread();
      },
      deep: true,
    },
    status: function(val, oldVal) {
      console.log(val);
      // this.params.status = val;
      // this.page = 1;
      this.searchThread();
    },
    search: function(val, oldVal) {
      this.params.search.search = val;
      if (!this.loading && (val.length > 3 || oldVal.length > val.length)) {
        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStop(val);
        }, 500);
      }
    },
    page: function(val, oldVal) {
      // this.params.page = val;
      console.log(val);

      this.searchThread();
    },
    read: function(val, oldVal) {
      console.log(val);
      this.searchThread();
    },
    unreadMessages: function(val, oldVal) {
      console.log(val);
      this.searchThread();
    },
    premiumUsers: function(val, oldVal) {
      this.searchThread();
    },
  },
};
</script>

<style lang="scss" scoped>
.og-select-category {
  max-width: 500px;
}

.og-thread-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>

<style lang="scss">
.og-thread-list {
  .v-list__tile {
    height: 100% !important;
  }
}
.admin-thread-notification-badge {
  .v-badge__badge {
    right: 15px !important;
  }
}
</style>
